import { CreateQCKeywordPayload, UpdateQCKeywordPayload, QCKeyword } from 'app/common/services/SmartQC.service';

export enum FormFieldCode {
  CODE = 'code',
  CATEGORY_IDs = 'categoryIds',
}

export function buildCreateQCKeywordModel() {
  return {
    [FormFieldCode.CODE]: '',
    [FormFieldCode.CATEGORY_IDs]: [],
  };
}

export function buildEditQCKeywordModel(qcKeyword: QCKeyword) {
  return {
    [FormFieldCode.CODE]: qcKeyword.code,
    [FormFieldCode.CATEGORY_IDs]: !qcKeyword.categoryIds.length ? [] : qcKeyword.categoryIds,
  };
}

export function buildCreateQCKeywordPayload(model: any) {
  const payload: CreateQCKeywordPayload = {
    [FormFieldCode.CODE]: model[FormFieldCode.CODE],
  };

  if (Array.isArray(model[FormFieldCode.CATEGORY_IDs]) && model[FormFieldCode.CATEGORY_IDs].length > 0) {
    payload[FormFieldCode.CATEGORY_IDs] = model[FormFieldCode.CATEGORY_IDs];
  }

  return payload;
}

export function buildEditQCKeywordPayload(model: any, qcKeyword: QCKeyword): UpdateQCKeywordPayload {
  const payload = {
    [FormFieldCode.CATEGORY_IDs]: model[FormFieldCode.CATEGORY_IDs],
  };

  if (qcKeyword.code !== model[FormFieldCode.CODE]) {
    payload[FormFieldCode.CODE] = model[FormFieldCode.CODE];
  }

  return payload;
}

export function buildTableColumns() {
  return [
    {
      title: 'Mã',
      key: 'code',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/setting/keyword/setting-keyword.util.ts